/*=========================================================================================
  File Name: moduleSmsState.js
  Description: Sms Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    mails: [],
    mail_filter: null,
    mailTags: [],
    meta: {},
    mailSearchQuery: '',
}
